import { useState } from 'react';
import { Box, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import TopBar from './TopBar';
import NavDrawer from './NavDrawer';
import { UnreadEmailProvider } from '../../contexts/UnreadEmailContext';

export default function AppShell() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <UnreadEmailProvider>
      <Box sx={{ display: 'flex' }}>
        <TopBar onMenuClick={() => setDrawerOpen(true)} />
        <NavDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
        <Box component="main" sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, overflowX: 'hidden' }}>
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
    </UnreadEmailProvider>
  );
}
